module.exports = __webpack_public_path__ + "static/media/31-iveco.051cfd17.jpg";